import { memo } from 'react'

export type LessonDecision = 'interested' | 'decline' | null

export interface LessonDecisionToggleProps {
  decision: LessonDecision
  onChoose: (decision: LessonDecision) => void
  disabled?: boolean
}

const SIZE_CLASSES = {
  button: 'px-2 py-1 text-[10px]',
}

const INACTIVE = 'text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'

const ACTIVE_OPEN = 'bg-orange-500 text-white'
const ACTIVE_INTERESTED = 'bg-blue-500 text-white'
const ACTIVE_DECLINE = 'bg-red-500 text-white'

export const LessonDecisionToggle = memo(function LessonDecisionToggle({
  decision,
  onChoose,
  disabled = false,
}: LessonDecisionToggleProps) {
  const handleChoose = (target: 'interested' | 'decline') => {
    if (disabled) return
    onChoose(decision === target ? null : target)
  }

  const handleOpen = () => {
    if (disabled) return
    onChoose(null)
  }

  return (
    <div className={`inline-flex bg-gray-100 dark:bg-gray-700 rounded-lg p-0.5 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
      <button
        type="button"
        onClick={handleOpen}
        className={`${SIZE_CLASSES.button} rounded-md font-medium transition-colors ${
          decision === null ? ACTIVE_OPEN : INACTIVE
        }`}
        aria-pressed={decision === null}
      >
        Offen
      </button>
      <button
        type="button"
        onClick={() => handleChoose('interested')}
        className={`${SIZE_CLASSES.button} rounded-md font-medium transition-colors ${
          decision === 'interested' ? ACTIVE_INTERESTED : INACTIVE
        }`}
        aria-pressed={decision === 'interested'}
      >
        Interessiert
      </button>
      <button
        type="button"
        onClick={() => handleChoose('decline')}
        className={`${SIZE_CLASSES.button} rounded-md font-medium transition-colors ${
          decision === 'decline' ? ACTIVE_DECLINE : INACTIVE
        }`}
        aria-pressed={decision === 'decline'}
      >
        Ablehnen
      </button>
    </div>
  )
})
